/* src/app/views/template/components/edit-template-menu/edit-template-marketing-menu/edit-template-marketing-menu-footer/edit-template-marketing-menu-footer.component.scss */
/*# sourceMappingURL=edit-template-marketing-menu-footer.component.css.map */
